<ng-container *transloco="let t; read: 'comparison-filter-item.keyword-item'">
  <xi-dropdown
    placeholder="{{ t('select-keyword') }}"
    [value]="displayValue"
    [data]="keywords"
    [disabled]="!isEnabled"
    [readOnly]="isReadOnly"
    [stretch]="true"
    (click)="openKeywordSelector($event)"
    cdkOverlayOrigin
    #keywordTrigger="cdkOverlayOrigin"
  ></xi-dropdown>

  @if (isLoading && !isKeywordSelectorVisible) {
    <div class="xi-loader-container__inline-overlay">
      <xi-animation [height]="35" [width]="35" [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="keywordTrigger"
    [cdkConnectedOverlayOpen]="isKeywordSelectorVisible"
    [cdkConnectedOverlayWidth]="333"
    [cdkConnectedOverlayHeight]="333"
    [cdkConnectedOverlayPositions]="{
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
    }"
    (overlayOutsideClick)="isKeywordSelectorVisible = false"
  >
    <div class="comparison-filter-keyword-item__popup">
      <div class="comparison-filter-keyword-item__search">
        <xi-search-box
          placeholder="{{ t('search-placeholder') }}"
          [status]="searchStatus"
          [stretch]="true"
          [hasOutline]="false"
          (keyup)="search$.next($event.target.value)"
          (onCancelClick)="search$.next('')"
        ></xi-search-box>
      </div>

      <div class="comparison-filter-keyword-item__radios">
        <xi-radio
          [value]="'contain'"
          [(ngModel)]="filterType"
          label="{{ t('contains-label') }}"
          name="keywordSearchType"
        ></xi-radio>

        <xi-radio
          [value]="'not-contain'"
          [(ngModel)]="filterType"
          label="{{ t('does-not-contain-label') }}"
          name="keywordSearchType"
        ></xi-radio>
      </div>

      <div class="comparison-filter-keyword-item__keyword-wrapper">
        @for (keyword of resultsPage?.items; track keyword) {
          <div
            (click)="onFilterValueSet(keyword.label)"
            class="comparison-filter-keyword-item__keyword-row"
          >
            <span>{{ keyword.label }}</span>
            <span class="comparison-filter-keyword-item__keyword-count">{{ keyword.count }}</span>
          </div>
        }
        @if (isLoading) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
        @if (!resultsPage?.items.length) {
          <div class="comparison-filter-keyword-item__empty-view">
            {{ t('no-results') }}
          </div>
        }
      </div>

      @if (hasMore()) {
        <div class="comparison-filter-keyword-item__show-more">
          <span (click)="showMore()">
            {{
              t('show-more', {
                results: resultsPage?.current * resultsPage?.size,
                length: resultsPage?.length,
              })
            }}
          </span>
        </div>
      }
    </div>
  </ng-template>
</ng-container>
